const module = { name: 'Fandango/sanitizer', exports: {} }; const exports = module.exports;



const RegExes = {
    TRUE: /^(?:yes|true|1|ok|on)$/i,
    FALSE: /^(?:no|false|0|off)$/i,
    HTML_NO_SCRIPT: /(<|&lt;)\s*(s|&#(115|83|53|73);)\s*c\s*r\s*i\s*p\s*t\s/gi,
    NOT_NUM: /\D/g,
    NOT_ALLOWED: /[^\w\s\-&.,+(){}!@?'"/=%–:—]/ig,
    NOT_ID: /[^a-z0-9]/gi,
    NUMBER: /(\d+(?:\.\d+)?)/,
    URL_DISALLOWED: /[^a-z0-9:/_\-#=&?.,+%']/ig,
    ZIP: /^[\w- ]+$/
}
function cleanInteger(value, defaultValue) {
    if (arguments.length < 2) {
        defaultValue = '';
    }
    if (value === null) {
        return defaultValue;
    }
    if (!isNaN(value)) {
        return parseInt(value);
    }
    if (!value) {
        return defaultValue;
    }
    const result = ('' + value).replace(RegExes.NOT_NUM, '');
    if (!result || isNaN(result)) {
        return defaultValue;
    }
    return parseInt(result);
}
function cleanText(value) {
    if (typeof value !== 'string' && typeof value !== 'number') {
        return '';
    }
    const result = ('' + value).replace(RegExes.NOT_ALLOWED, '');
    return result || '';
}
function cleanId(value) {
    return cleanText(value).replace(RegExes.NOT_ID, '');
}
function cleanNumber(value, defaultValue) {
    if (typeof value === 'number') {
        return value;
    }
    if (arguments.length < 2) {
        defaultValue = '';
    }
    value = '' + value;
    if (!RegExes.NUMBER.test(value)) {
        return defaultValue;
    }
    const m = value.match(RegExes.NUMBER);
    return parseFloat(m[1]);
}
function cleanBoolean(value, defaultValue) {
    value = ('' + value).trim();
    defaultValue = arguments.length > 1 ? defaultValue : false;
    if (RegExes.TRUE.test(value)) {
        return true;
    }
    else if (RegExes.FALSE.test(value)) {
        return false;
    }
    else {
        return defaultValue;
    }
}
function cleanURL(value) {
    if (typeof value !== 'string' || !value) {
        return '';
    }
    return value.replace(RegExes.URL_DISALLOWED, '');
}
function cleanZip(value) {
    if (typeof value !== 'string' && typeof value !== 'number') {
        return '';
    }
    if (!RegExes.ZIP.test(value)) {
        return '';
    }
    return value + '';
}
function cleanHTML(value) {
    return ('' + value).replace(RegExes.HTML_NO_SCRIPT, '');
}
function isPlainObject(value) {
    if (!value || typeof value !== 'object') {
        return false;
    }
    let proto = value;
    while (Object.getPrototypeOf(proto) !== null) {
        proto = Object.getPrototypeOf(proto);
    }
    return Object.getPrototypeOf(value) === proto;
}
function extendLegacy(area, publicInterface) {
    window.Fandango = window.Fandango || {};
    const { Fandango } = window;
    if (!Fandango[area]) {
        Fandango[area] = publicInterface;
    }
}
module.exports = {
    isPlainObject,
    boolean: cleanBoolean,
    html: cleanHTML,
    id: cleanId,
    integer: cleanInteger,
    number: cleanNumber,
    text: cleanText,
    url: cleanURL,
    zip: cleanZip
};
extendLegacy('sanitizer', module.exports);
export default module.exports;